<template lang='pug'>
  v-layout(align-top justify-center)
    div.text-xs-center
      v-icon(size='180' color='primary') error
      h1.font-weight-regular Page Not Found
      .subheading.pb-5 Please check the address and try again!
      v-btn(flat color='primary' @click='home') Home
</template>
<script>
export default {
  methods: {
    home() {
      this.$router.push('/');
    },
  },
};
</script>